export const BASE_URL: string = process.env.REACT_APP_API_KEY || '';
// export const BASE_URL: string = 'http://178.128.61.122:8085';

export const OFFICER_PROFILE_FIND_MANY = BASE_URL + '/profile/officer-profile/find-many';
export const OFFICER_PROFILE_UPDATE = BASE_URL + '/profile/officer-profile/update?Id=';
export const OFFICER_PROFILE_DELETE = BASE_URL + '/profile/officer-profile/delete?Id=';
